import { create } from 'zustand';
import type { AccountInfo } from '@azure/msal-browser';

import type { AppRole as SharedAppRole } from '@cds/shared';

/** Role names as strings; the enum and ordering are single-sourced in @cds/shared (authz Phase A). */
type AppRole = `${SharedAppRole}`;

interface AuthState {
  account: AccountInfo | null;
  accessToken: string | null;
  isAuthenticated: boolean;
  role: AppRole | null;
  setAccount: (account: AccountInfo | null) => void;
  setAccessToken: (token: string | null) => void;
  setRole: (role: AppRole) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  account: null,
  accessToken: null,
  isAuthenticated: false,
  role: null,
  setAccount: (account) =>
    set({ account, isAuthenticated: !!account }),
  setAccessToken: (accessToken) =>
    set({ accessToken }),
  setRole: (role) =>
    set({ role }),
  logout: () =>
    set({ account: null, accessToken: null, isAuthenticated: false, role: null }),
}));
